/* eslint-disable */
import { css } from 'styled-components';
import { TOUCH_SUPPORTED } from './features';

/**
 * Reset stylesheet.
 */
export const reset = () => {
  return `html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:'';content:none}table{border-collapse:collapse;border-spacing:0}`;
};

/**
 * Common styles. Overflows are important because the Pace/Helios nav creates inline styles on <html> and <body>
 */
export const commonStyles = () => {
  return `
    html {
      box-sizing: border-box;
    }
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
    html{
      overflow-x: hidden !important;
      overflow-y: hidden !important;
    }
    body {
      font-family: NissanBrand-Regular, arial, helvetica, verdana, sans-serif;
      overflow-x: hidden !important;
      overflow-y: hidden !important;
      width: 100%;
      height: 100%;
      background-color: #fff;
    }
    html.enable-scrolling,
    html.enable-scrolling body{
      overflow-y: auto !important;
      height: auto;
    }
    html.hide-global-navigation{
      #nna-responsive-navigation,
      #footer-section-bar-wrapper,
      #nissan_global_header,
      #nissan_global_footer,
      .nna-navigation-standalone-base{
        display: none;
      }
    }
    html.hide-metrical-container{
      .MetricalContainer{
        display: none;
      }
    }
    img {
      max-width: 100%;
    }
  `;
};

/**
 * Hides the Metrical Feedback Survey button
 */
export const hideMetricalContainer = () => {
  return `
    .MetricalContainer{
      display: none;
    }
  `;
};

/**
 * Use this if you don't want a toch device to trigger your hover effects.
 * Only applies the :hover pseudo class on a devices without touch events.
 *
 * @param {String} hoverCss Styles to apply on hover
 */
export const hoverIgnoreTouch = (hoverCss) => {
  if (!TOUCH_SUPPORTED) {
    return css`
      &:hover {
        ${hoverCss};
      }
    `;
  }
};

export function horizontalCenterAlign(position) {
  return `
    position: ${position};
    left: 50%;
    right: auto;
    transform: translateX(-50%);
  `;
}

export function verticalCenterAlign(position) {
  return `
    position: ${position};
    top: 50%;
    bottom: auto;
    transform: translateY(-50%);
  `;
}
export function deadCenterAlign(position) {
  return `
    position: ${position};
    top: 50%;
    right: auto;
    bottom: auto;
    left: 50%;
    transform: translate(-50%, -50%);
  `;
}

export function textShadow(color) {
  return `
    text-shadow: 2px 2px 1px ${color};
  `;
}

export function fadeIn(opacity) {
  return `
    animation-name: fadeIn;
    animation-timing-function: ease-in;
    animation-duration: .5s;
    animation-fill-mode: forwards;

    @keyframes fadeIn {
        100% {
            opacity: ${opacity};
        }
    }`;
}

export function arrowBounce() {
  return `
  animation: bounce 750ms ease-out forwards;
  @keyframes bounce {
    0% {
      padding: 0;
    }
    10% {
      padding: 0;
    }
    20% {
      padding: 5px 0 0 0;
    }
    30% {
      padding: 0;
    }
    100% {
      padding: 0;
    }
  }
  `;
}
/* eslint-enable */



/** WEBPACK FOOTER **
 ** ./src/css/mixins.js
 **/